import { getEnv } from '@atlassian/pillar/runtime/env';

import {
	DEFAULT_TENANT_CLOUD_ID,
	HELLO_ORG_ID_PROD,
	PUG_CLOUD_ID_STG,
	PUG_ORG_ID_STG,
} from '../ui/pages/labs/home/constants';

const config = {
	atlassianHomeUrl: 'https://home.stg.atlassian.com',
	atlassianAccountUrl: 'https://id.stg.internal.atlassian.com',
	serviceUrl: 'https://dtac.stg-east.frontend.public.atl-paas.net',
	graphStoreUrl: 'https://ari-graph-store.staging.atl-paas.net',
	// Default cloud ID for the X-Query-Context site ARI.
	// Staging uses the PUG staging instance; production uses the real tenant.
	defaultSiteCloudId: PUG_CLOUD_ID_STG,
	featureGateApiKey: 'ea6bcda3-64dd-4743-88bc-8852b0a46b2a', // https://hello.help.atlassian.cloud/servicedesk/customer/portal/3450/MHD-16936?created=true
	orgId: PUG_ORG_ID_STG,
};
// When running locally (via pillar dev), always route graph-store through the local proxy to
// avoid CORS issues. The proxy target (staging vs production) is configured in pillar.config.ts.
const isLocalDev =
	typeof window !== 'undefined' &&
	(window.location.hostname === 'localhost' || window.location.hostname.includes('localhost'));

const environmentOverrides: Partial<Record<ReturnType<typeof getEnv>, Partial<typeof config>>> = {
	staging: {
		atlassianHomeUrl: 'https://home.stg.atlassian.com',
		atlassianAccountUrl: 'https://id.stg.internal.atlassian.com',
		serviceUrl: 'https://dtac.stg-east.frontend.public.atl-paas.net',
		graphStoreUrl: 'https://ari-graph-store.staging.atl-paas.net',
		defaultSiteCloudId: PUG_CLOUD_ID_STG,
		orgId: PUG_ORG_ID_STG,
		featureGateApiKey: 'ea6bcda3-64dd-4743-88bc-8852b0a46b2a',
	},
	production: {
		atlassianHomeUrl: 'https://home.atlassian.com',
		atlassianAccountUrl: 'https://id.atlassian.com',
		serviceUrl: 'https://dtac.prod-east.frontend.public.atl-paas.net',
		graphStoreUrl: isLocalDev ? '/api/graph-store' : 'https://ari-graph-store.staging.atl-paas.net',
		defaultSiteCloudId: DEFAULT_TENANT_CLOUD_ID,
		featureGateApiKey: 'c02e59c8-4226-40b6-96fb-af03f67d1cf5', // https://hello.help.atlassian.cloud/servicedesk/customer/portal/3450/MHD-16936?created=true`
		orgId: HELLO_ORG_ID_PROD,
	},
	development: {
		// Use local proxy to avoid CORS issues
		graphStoreUrl: '/api/graph-store',
	},
	local: {
		// Use local proxy to avoid CORS issues
		graphStoreUrl: '/api/graph-store',
	},
};

export const getConfig = (): {
	isLocalDev: boolean;
	atlassianHomeUrl: string;
	atlassianAccountUrl: string;
	serviceUrl: string;
	graphStoreUrl: string;
	defaultSiteCloudId: string;
	featureGateApiKey: string;
	orgId: string;
	env: 'production' | 'staging' | 'development' | 'local';
} => {
	const env = getEnv();

	return {
		env,
		...config,
		...environmentOverrides[env],
		isLocalDev,
	};
};
